/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Pagination_RowsInputs */

const es_admin_traces_pagination_rows = /** @type {(inputs: Admin_Traces_Pagination_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas`)
};

const en_admin_traces_pagination_rows = /** @type {(inputs: Admin_Traces_Pagination_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows`)
};

/**
* | output |
* | --- |
* | "Rows" |
*
* @param {Admin_Traces_Pagination_RowsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_pagination_rows = /** @type {((inputs?: Admin_Traces_Pagination_RowsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Pagination_RowsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_pagination_rows(inputs)
	return en_admin_traces_pagination_rows(inputs)
});
export { admin_traces_pagination_rows as "admin.traces.pagination.rows" }